import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const cases_endorsements:SchemaTableOptions = {
    name:<string> 'cases_endorsements',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'cases_id', value: 'INTEGER UNSIGNED'},
        { column: 'endorsed_trainee_id', value: 'INTEGER UNSIGNED'},
    ]
}